import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "./components/layout/Layout";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import MensHealth from "./pages/MensHealth";
import About from "./pages/About";
import NewPatients from "./pages/NewPatients";
import Contact from "./pages/Contact";
import Accessibility from "./pages/Accessibility";
import ErectileDysfunction from "./pages/services/ErectileDysfunction";
import PeyroniesDisease from "./pages/services/PeyroniesDisease";
import LowTestosterone from "./pages/services/LowTestosterone";
import BPH from "./pages/services/BPH";
import Vasectomy from "./pages/services/Vasectomy";
import Urodynamics from "./pages/services/Urodynamics";
import GAINSWave from "./pages/services/GAINSWave";
import SimpleServicePage from "./pages/services/SimpleServicePage";

function App() {
  return (
    <HelmetProvider>
      <div className="App font-body">
        <BrowserRouter>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/mens-health" element={<MensHealth />} />
              <Route path="/services/erectile-dysfunction" element={<ErectileDysfunction />} />
              <Route path="/services/peyronies-disease" element={<PeyroniesDisease />} />
              <Route path="/services/low-testosterone" element={<LowTestosterone />} />
              <Route path="/services/bph" element={<BPH />} />
              <Route path="/services/vasectomy" element={<Vasectomy />} />
              <Route path="/services/urodynamics" element={<Urodynamics />} />
              <Route path="/services/gainswave" element={<GAINSWave />} />
              <Route path="/services/:slug" element={<SimpleServicePage />} />
              <Route path="/about" element={<About />} />
              <Route path="/new-patients" element={<NewPatients />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/accessibility" element={<Accessibility />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
